export const DEFAULT_LOCALE = process.env.VUE_APP_I18N_LOCALE || 'en'
export const LOCALES = process.env.VUE_APP_I18N_LOCALES || 'en,hu'
export const FALLBACK_LOCALE = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en'
